module.exports = __webpack_public_path__ + "StagoWeb-x16.cd0ba92d93cee588ee8b.ttf";


//////////////////
// WEBPACK FOOTER
// D:/Ai3/Stago/SAST/Sources/SAST/src/Stago.AAI/ClientAppAngular/src/_stylesheets/fonts/icons/StagoWeb-x16.ttf
// module id = ../../../../../src/_stylesheets/fonts/icons/StagoWeb-x16.ttf
// module chunks = styles